var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg447E447E10282956B81289A96893Ff9Dcbf5C994C06Cab37C72Bc161Cd26F0Aa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.65714C0 2.37702 -1.00136e-07 1.73696 0.254322 1.24802C0.478018 0.817931 0.834972 0.468263 1.27402 0.249131C1.77315 -9.80922e-08 2.42655 0 3.73333 0H7.78694C8.35765 0 8.64302 2.08446e-07 8.91158 0.0631545C9.14958 0.119143 9.3772 0.211497 9.58603 0.336823C9.82147 0.478172 10.0233 0.675829 10.4268 1.07115L10.5731 1.21456C10.9767 1.60989 11.1785 1.80754 11.414 1.94889C11.6228 2.07422 11.8504 2.16657 12.0884 2.22256C12.357 2.28571 12.6423 2.28571 13.2131 2.28571H17.2667C18.5734 2.28571 19.2269 2.28571 19.726 2.53485C20.165 2.75398 20.522 3.10365 20.7457 3.53374C21 4.02267 21 4.66274 21 5.94286V12.3429C21 13.623 21 14.2631 20.7457 14.752C20.522 15.1821 20.165 15.5318 19.726 15.7509C19.2269 16 18.5734 16 17.2667 16H3.73333C2.42654 16 1.77315 16 1.27402 15.7509C0.834972 15.5318 0.478018 15.1821 0.254322 14.752C-1.00136e-07 14.2631 0 13.623 0 12.3429V3.65714Z",
    fill: "#424143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg447E447E10282956B81289A96893Ff9Dcbf5C994C06Cab37C72Bc161Cd26F0Aa);
export default __webpack_public_path__ + "static/media/447e447e10282956b81289a96893ff9dcbf5c994c06cab37c72bc161cd26f0aa.2978f7a004f5e5a0afc316abee6f224c.svg";
export { ForwardRef as ReactComponent };